export const hasValue = (obj: any, value: any) => {
  let key: keyof typeof obj;
  for (key in obj) {
    if (obj[key] === value) {
      return true;
    }
  }
  return false;
};
